import React from 'react';
import PropTypes from 'prop-types';

import { ResponsiveContainerFragment } from './ResponsiveContainer.gql';
import { DesktopOnly, MobileOnly } from './ResponsiveContainer.styled';
import CardContainer from '../CardContainer/CardContainer.pim';
import CardSection from '../ContentSystem/components/CardSection/CardSection';
import ContentBlock from '../ContentBlock/ContentBlock.pim';
import HeaderBlock from '../HeaderBlock.pim/HeaderBlock';
import HeaderSection from '../ContentSystem/components/HeaderSection/HeaderSection';
import ImageSection from '../ContentSystem/components/ImageSection/ImageSection';
import TextBlock from '../ContentfulTextBlock/ContentfulTextBlock.pim';
import TextSection from '../ContentSystem/components/TextSection/TextSection';

/**
 * A container that displays components on either small/medium screens or large screens
 */
const ResponsiveContainer = ({ desktopOnly, mobileOnly }) => {
  const blocksMap = {
    CardContainer,
    ContentBlock,
    HeaderBlock,
    TextBlock,
    CardSection,
    HeaderSection,
    ImageSection,
    TextSection
  };

  const renderModule = (module) => {
    const Module = blocksMap[module.__typename];

    if (blocksMap[module.__typename]) {
      return <Module key={module.id || module.title} {...module} />;
    }
  };

  return (
    <>
      <MobileOnly>
        {mobileOnly.map((module) => renderModule(module))}
      </MobileOnly>
      <DesktopOnly>
        {desktopOnly.map((module) => renderModule(module))}
      </DesktopOnly>
    </>
  );
};

ResponsiveContainer.propTypes = {
  /**
   * An array of modules to be shown only on large screens
   */
  desktopOnly: PropTypes.arrayOf(PropTypes.shape({})),
  /**
   * An array of modules to be shown only on small/medium screens
   */
  mobileOnly: PropTypes.arrayOf(PropTypes.shape({}))
};

ResponsiveContainer.defaultProps = {
  desktopOnly: [],
  mobileOnly: []
};

ResponsiveContainer.fragment = ResponsiveContainerFragment;

export default ResponsiveContainer;
